// extracted by mini-css-extract-plugin
export var currencyInput = "_lh-1";
export var currencySymbol = "_lh-0";